import React, { useContext } from 'react';
import { CheckIcon } from '../../Icons';
import { ChipGroupContext } from '../ChipGroup';
import { chipVariants } from '../logic';
import styles from './styles.module.scss';

type Props = {
  /** この Chip が表す値。ChipGroup の value と照合して選択状態を決定する */
  value: string;
  /** 無効状態。デフォルト: false */
  disabled?: boolean;
  /** サイズ。デフォルト: 'md' */
  size?: 'sm' | 'md' | 'lg';
  /** スタイルバリアント。デフォルト: 'default' */
  variant?: 'default' | 'secondary';
  children: React.ReactNode;
  /** 追加のクラス名 */
  className?: string;
};

export const Chip: React.FC<Props> = ({
  value,
  disabled = false,
  size = 'md',
  variant = 'default',
  children,
  className,
}) => {
  const { isMulti, selectedValues, onSelect } = useContext(ChipGroupContext);
  const selected = selectedValues.includes(value);
  const showCheckIcon = isMulti && selected;

  return (
    <button
      type='button'
      aria-pressed={selected}
      disabled={disabled}
      onClick={() => onSelect(value)}
      className={[
        chipVariants({ size, variant, selected }),
        showCheckIcon ? styles.withIcon : undefined,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {showCheckIcon && <CheckIcon size='xs' aria-hidden />}
      {children}
    </button>
  );
};
